"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPumpCurveOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M6 11.05c3 .29 8 2.1 8 11h2c0-6-2.08-9.24-4.49-11 6 .1 9.89 1.16 12 3.3C25.23 16 26 18.45 26 22h2c0-4.06-1-7-3-9.11C22.26 10.2 17.81 9 10.51 9H6V4H4v24h24v-2H6z" })));
}
exports.default = SvgPumpCurveOutline;
//# sourceMappingURL=PumpCurveOutline.js.map